import { varOpaque } from "@stellar/js-xdr";
import { UNBOUNDED_MAX_LENGTH } from "@stellar/js-xdr";
import { BytesValue } from "../values/bytes-value.js";

export type EncodedLedgerKeyWire = Uint8Array;

/**
 * ```xdr
 * typedef opaque EncodedLedgerKey<>;
 * ```
 */
export class EncodedLedgerKey extends BytesValue<"EncodedLedgerKey"> {
  static readonly encoding = "hex" as const;
  static readonly schema = varOpaque(UNBOUNDED_MAX_LENGTH, "EncodedLedgerKey");

  static fromXdrObject(wire: Uint8Array): EncodedLedgerKey {
    return new EncodedLedgerKey(wire);
  }
}
